module.exports = __webpack_public_path__ + "media/images/application/template/logos/trustpilot-2022-a796c8881a895df6e3bf52c3df422ba1.png";